import React from "react";
import { Box, Typography } from "@mui/material";
import { textPrimary, textSecondary } from "../constants/consts";

export default function AppPageHeader({
  title,
  subtitle,
  trailing,
  onDark = false,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start", // ← center yerine
        justifyContent: "space-between",
        gap: 2,
        mb: 3, // ← 1'den 3'e çıkar, alt içerikle boşluk
        width: "100%",
      }}
    >
      <Box>
        <Typography
          variant="h5"
          fontWeight={700}
          color={onDark ? "#fff" : textPrimary}
          gutterBottom
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="body2"
            color={onDark ? "rgba(255,255,255,0.85)" : textSecondary}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {trailing && <Box>{trailing}</Box>}
    </Box>
  );
}
